export default {
      id: "right-arrow-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "app/svg/sprite.svg#right-arrow",
      toString: function () {
        return this.url;
      }
    }